import * as R from 'ramda';

import AddReplenishmentForm from '@atom/components/common/requests/viewRequest/sddotView/AddReplenishmentForm';
import { TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import {
  AssetRequestCreateInput,
  ReplenishmentCreateInput,
} from '@atom/types/assetRequest';
import { AssetBudget, InventoryAssetDetailType } from '@atom/types/inventory';

import classes from './sddotCreate.module.css';

const styles = {
  label: {
    color: colors.neutral.dim,
  },
  orderedInput: {
    width: '13.75rem',
  },
};

interface Props {
  budget: AssetBudget;
  createInputs: AssetRequestCreateInput;
  updateCreateInput: (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => void;
  asset: InventoryAssetDetailType;
}

const SDDOTReplenishmentCreate = ({
  budget,
  createInputs,
  updateCreateInput,
  asset,
}: Props) => {
  const totalQuantityReceived =
    createInputs?.replenishment?.quantityReceived || 0;
  const totalQuantityRemaining =
    R.pathOr(0, ['quantityOrdered'], createInputs) - totalQuantityReceived;

  const updateReplenishmentInput = (
    value: any,
    property: keyof ReplenishmentCreateInput,
  ) => {
    const updatedReplenishment = {
      ...createInputs.replenishment,
      [property]: value,
    };

    updateCreateInput(updatedReplenishment, 'replenishment');
  };

  const numberUpdate = (
    value: any,
    property: keyof AssetRequestCreateInput,
  ) => {
    const updatedValue =
      Math.abs(Number(value)) > 0 ? Math.abs(Number(value)) : null;
    updateCreateInput(updatedValue, property);
  };

  return (
    <>
      <div className={classes.viewRow}>
        <div className={classes.rowTitle}>Inventory Name</div>
        <div>{asset?.name}</div>
      </div>
      <div className={classes.inputRow}>
        <TextField
          slotProps={{ inputLabel: { style: styles.label } }}
          style={styles.orderedInput}
          type="number"
          value={createInputs?.quantityOrdered || ''}
          label={`Total Quantity Ordered (${budget?.unit})`}
          onChange={event =>
            numberUpdate(event.target.value, 'quantityOrdered')
          }
          data-cy="assetRequestReplenishmentQuantity"
        />
        <div className={classes.dataCell}>
          <div
            className={classes.dataCellTitle}
          >{`Total Quantity Received (${budget?.unit})`}</div>
          <div>{totalQuantityReceived || '-'}</div>
        </div>
        <div className={classes.dataCell}>
          <div
            className={classes.dataCellTitle}
          >{`Total Remaining Quantity on Order (${budget?.unit})`}</div>
          <div>{totalQuantityRemaining || '-'}</div>
        </div>
      </div>
      <div className={classes.inputRow}>
        <AddReplenishmentForm
          assetUnit={budget?.unit}
          totalOrdered={createInputs.quantityOrdered}
          replenishmentInputs={createInputs.replenishment}
          updateReplenishmentInput={updateReplenishmentInput}
        />
      </div>
    </>
  );
};

export default SDDOTReplenishmentCreate;
